// Reserved ids for the canvas overlays that aren't backed by a real
// AField entity:
// - CUTTING_SHAPE_ID: the group holding the cut shape. Not selectable — the
//   id is how the engine finds the group again to mirror it, fade it,
//   strip it from an export or remove it.
// - GRID_HELPER_ID: the alignment overlay. User-toggleable, per-product
//   asset, but excluded from reorder / lock / export.
//
// - BACKGROUND_PATTERN_ID: the repeated motif laid over the background colour. Unlike the two
//   above it is part of the artwork, so it stays in every export; it is not selectable.
//
// An engine that surfaces GRID_HELPER_ID as a selection must tag its
// own view (fabric group id, three object userData, ...) with this
// exact string so deriveSelectionKind can translate the id into a
// domain-level ESelectionKind.

const CUTTING_SHAPE_ID = 'cuttingGroup';
const GRID_HELPER_ID = 'gridHelperGroup';
const BACKGROUND_PATTERN_ID = 'backgroundPatternGroup';

export { BACKGROUND_PATTERN_ID, CUTTING_SHAPE_ID, GRID_HELPER_ID };
